import { useMemo } from "react";

import { FILES } from "b2b/api";

export default function useImagePreview(value) {
  return useMemo(() => {
    if (value) {
      if (value.key) {
        return {
          url: FILES.provozniInformace(value.key),
          method: "get",
          options: {
            attachment: "base64",
            headers: { accept: "application/octet-stream" }
          }
        };
      } else {
        try {
          return URL.createObjectURL(value);
        } catch (e) {
          console.warn("Nepodařilo se vytvorit nahled obrazku!", e); //eslint-disable-line
        }
      }
    } else {
      return undefined;
    }
  }, [value]);
}
